const getCookieConsent = function () {
  if (typeof window !== 'undefined') {
    // extract the OptanonConsent cookie from the document
    let OptanonConsent = document.cookie.split(';').find((cookie) => cookie.trim().startsWith('OptanonConsent='));

    if (!OptanonConsent) {
      OptanonConsent = 'OptanonConsent=';
    }

    const params = new URLSearchParams(OptanonConsent.replace('OptanonConsent=', '').trim());

    const result = {};

    result.consentId = params.has('consentId') ? params.get('consentId') : null;

    const groups = params.has('groups') ? params.get('groups').split(',') : [];

    result.consent = {
      necessary: groups.includes('C0001:1') ?? false,
      performance: groups.includes('C0002:1') ?? false,
      functional: groups.includes('C0003:1') ?? false,
      targeting: groups.includes('C0004:1') ?? false,
      social: groups.includes('C0005:1') ?? false,
    };

    // For OneTrust Checkout Functionality
    const groupsString = params.get('groups');
    result.groups = groupsString;

    return result;
  }
};

export default defineNuxtPlugin((nuxtApp) => {
  const getCurrentLocaleConfig = function (localeOverwrite = null) {
    const { locale, locales } = nuxtApp.$i18n;
    const findLocale = localeOverwrite ?? locale.value;

    return locales.value.find((l) => l.code === findLocale);
  };

  return {
    provide: {
      getCookieConsent,
      getCurrentLocaleConfig,
    },
  };
});
